import React, { useState } from "react";
import verificationDiagram from "../../assets/pub-verification-diagram.svg";

const POINTS = [
    {
        title: "Geo-tagged media with time & location stamps",
        desc: "Every capture is location and time stamped",
    },
    {
        title: "Live status, viewable from anywhere, on any project",
        desc: null,
    },
    {
        title: "Immutable audit trail with version control",
        desc: null,
    },
    {
        title: "Company-linked identity & role verification",
        desc: null,
    },
    {
        title: "Content Authenticity (C2PA) support",
        desc: null,
    },
];

const PubVerification = () => {
    const [active, setActive] = useState(0);

    return (
        <section className="pub-verification">
            <div className="pub-verification-inner">
                <div className="pub-verification-left">
                    <p className="pub-ver-overtitle">The Conra Verification Engine</p>
                    <h2 className="pub-ver-heading">Built for remote, built for proof</h2>
                    <p className="pub-verification-sub">
                        Every photo, document and data point behind a Conra record is authentic, tamper-proof and context-rich — which is what makes trusting it from a distance possible in the first place.
                    </p>
                    <ul className="pub-verification-points">
                        {POINTS.map((p, i) => (
                            <li
                                key={i}
                                className={`pub-ver-point${i === active ? " pub-ver-point--active" : ""}`}
                                onClick={() => setActive(i)}
                            >
                                <span className="pub-ver-point-title">{p.title}</span>
                                {i === active && p.desc && (
                                    <span className="pub-ver-point-desc">{p.desc}</span>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="pub-verification-right">
                    <img
                        src={verificationDiagram}
                        alt="ConRa Verification Engine diagram"
                        className="pub-ver-diagram-img"
                    />
                </div>
            </div>
        </section>
    );
};

export default PubVerification;
